import store from "@/state/store";

export default [
 
  {
    path: "/",
    name: "root",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/pages/dashboard/projects/index.vue"),
  },
   {
    path: "/job-list",
    name: "job-order",
    meta: {
      title: "job-order",
      authRequired: true,
    },
    component: () => import("../views/pages/job-order/list.vue"),
  },
    {
    path: "/create-job-order",
    name: "create-job-order",
    meta: {
      title: "create-job-order",
      authRequired: true,
    },
    component: () => import("../views/pages/job-order/create.vue"),
  },
    {
    path: "/convert-job-order",
    name: "convert-job-order",
    meta: {
      title: "convert-job-order",
      authRequired: true,
    },
    component: () => import("../views/pages/job-order/convert.vue"),
  },
   {
    path: "/detail-job-order",
    name: "detail-job-order",
    meta: {
      title: "detail-job-order",
      authRequired: true,
    },
    component: () => import("../views/pages/job-order/detail.vue"),
  },
    {
    path: "/estimate",
    name: "estimate",
    meta: {
      title: "estimates",
      authRequired: true,
    },
    component: () => import("../views/pages/estimate/list.vue"),
  },
    {
    path: "/create-estimate",
    name: "create-estimate",
    meta: {
      title: "create-estimate",
      authRequired: true,
    },
    component: () => import("../views/pages/estimate/create.vue"),
  },
   {
    path: "/detail-estimate",
    name: "detail-estimate",
    meta: {
      title: "detail-estimate",
      authRequired: true,
    },
    component: () => import("../views/pages/estimate/detail.vue"),
  },
     {
    path: "/clients",
    name: "client",
    meta: {
      title: "clients",
      authRequired: true,
    },
    component: () => import("../views/pages/client/list.vue"),
  },
    {
    path: "/create-client",
    name: "create-client",
    meta: {
      title: "create-client",
      authRequired: true,
    },
    component: () => import("../views/pages/client/create.vue"),
  },
  {
    path: "/detail-client",
    name: "detail-client",
    meta: {
      title: "detail-client",
      authRequired: true,
    },
    component: () => import("../views/pages/client/detail.vue"),
  },
  
   
  {
    path: "/users",
    name: "user",
    meta: {
      title: "User",
      authRequired: true,
    },
    component: () => import("../views/pages/user/index.vue"),
  },
   {
    path: "/roles",
    name: "role",
    meta: {
      title: "Role",
      authRequired: true,
    },
    component: () => import("../views/pages/role/index.vue"),
  },
  
   {
    path: "/service",
    name: "service",
    meta: {
      title: "service",
      authRequired: true,
    },
    component: () => import("../views/pages/service/index"),
  },
  
   
   {
    path: "/login",
    name: "login",
    component: () => import("../views/pages/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/pages/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout", authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      },
    },
    component: () => import("../views/pages/account/logout.vue")
  },
   {
    path: "/verification-code",
    name: "Verification Code",
    component: () => import("../views/pages/account/code-verification.vue"),
    meta: {
      title: "Verification Code",
    
    },
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: () => import("../views/pages/account/reset-password.vue"),
    meta: {
      title: "Reset Password",
    
    },
  },
  {
    path: "/general-setting",
    name: "general-setting",
    meta: {
      title: "general-setting",
      authRequired: true,
    },
    component: () => import("../views/pages/setting/create.vue"),
  },
  {
    path: '/lockscreen',
    name: 'lock-screen',
    meta: {
      title: "Lock Screen", authRequired: true,
    },
    component: () => import('../views/pages/account/lockscreen.vue')
  },
   {
    path: "/profile",
    name: "profile",
    meta: { title: "Profile", authRequired: true },
    component: () => import("../views/pages/account/profile.vue"),
  },
  {
    path: '/auth/404',
    name: '404',
    meta: { title: "Error 404", authRequired: true },
    component: () => import('../views/pages/account/404-basic.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/auth/404'
  }
];